import { render, staticRenderFns } from "./FarmForm.vue?vue&type=template&id=3afa06f2"
import script from "./FarmForm.vue?vue&type=script&lang=js"
export * from "./FarmForm.vue?vue&type=script&lang=js"
import style0 from "./FarmForm.vue?vue&type=style&index=0&id=3afa06f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports